import { connect } from 'react-redux';
import { codeErrorSelector, hasCodeErrorSelector, isConfirmPhoneFormSubmittingSelector, sendSmsStatusSelector, viewDataEmailSelector, viewDataPhoneSelector } from './selectors';
import { confirmPhone as confirmPhoneAction, sendSms as sendSmsAction } from '../../../../actions/registration';
import { changeView as changeViewAction } from '../../../../actions/view';
import { emit as emitAction } from '../../../../actions/events';
import { FormContainer as Component } from './FormContainer';
import { sourceSelector } from '../../../../selectors/source';
export function mapStateToProps(state) {
  return {
    sendSmsStatus: sendSmsStatusSelector(state),
    isSubmitting: isConfirmPhoneFormSubmittingSelector(state),
    phone: viewDataPhoneSelector(state),
    email: viewDataEmailSelector(state),
    hasCodeError: hasCodeErrorSelector(state),
    codeError: codeErrorSelector(state),
    source: sourceSelector(state)
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    sendSms: function sendSms(parameters) {
      dispatch(sendSmsAction(parameters));
    },
    confirmPhone: function confirmPhone(parameters) {
      dispatch(confirmPhoneAction(parameters));
    },
    changeView: function changeView(view, data) {
      dispatch(changeViewAction(view, data));
    },
    emit: function emit(type, event) {
      dispatch(emitAction(type, event));
    }
  };
}
export var FormContainer = connect(mapStateToProps, mapDispatchToProps)(Component);